module.exports = __webpack_public_path__ + "static/img/5.7e3e15a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/5.jpg
// module id = sUSq
// module chunks = 1